import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ReviewPackageConfirmCompleteDialogComponent } from './review-package-confirm-complete-dialog.component';

@NgModule({
  declarations: [
    ReviewPackageConfirmCompleteDialogComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatToolbarModule
  ],
  exports: [
    ReviewPackageConfirmCompleteDialogComponent
  ]
})
export class ReviewPackageConfirmCompleteDialogModule { }
